import { Navigate, useParams } from 'react-router-dom';
import StartReadingExperience from '../components/StartReadingExperience';
import { isVersionKey } from '../lib/versions';

export default function TryReading() {
  const { version } = useParams<{ version: string }>();
  if (!isVersionKey(version)) return <Navigate to="/" replace />;
  return <StartReadingExperience initialVersion={version} showBackLink />;
}
